export default{
    // 获取微信签名等信息
    'getShare':'/signature',
    // 留言
    'sendMessage':'/recordNote'
}